import { render } from "./isvSelect.vue?vue&type=template&id=abd6765e"
import script from "./isvSelect.vue?vue&type=script&lang=js"
export * from "./isvSelect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\D\\work\\zhenbo\\code\\pay\\pay_admin_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__